import * as p from '@clack/prompts'
import { UNSUPPORTED_PROJECT_STATE_MESSAGE } from '@cli-constants/snapshots.js'
import { snapshotRootExists } from '@core-engine/snapshots/store/snapshot-root-exists.js'

export function assertSnapshotStateOrExit(cwd: string): void {
  if (snapshotRootExists(cwd)) {
    return
  }

  p.log.error(UNSUPPORTED_PROJECT_STATE_MESSAGE)
  process.exit(1)
}
